(function () {
  function bindItem(inner, btn) {
    if (!inner || !btn || inner.dataset.uspExpandBound === 'true') return;
    inner.dataset.uspExpandBound = 'true';

    var more = btn.querySelector('.collection-usps-accordion-toggle-text-more');
    var close = btn.querySelector('.collection-usps-accordion-toggle-text-close');
    if (!more || !close) return;

    function syncButton(collapsed) {
      inner.classList.toggle('is-collapsed', collapsed);
      btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      more.hidden = !collapsed;
      close.hidden = collapsed;
    }

    function measure() {
      inner.classList.remove('is-collapsed');
      void inner.offsetHeight;
      var fullHeight = inner.scrollHeight;
      inner.classList.add('is-collapsed');
      void inner.offsetHeight;
      var clampedHeight = inner.clientHeight;
      var needsToggle = fullHeight > clampedHeight + 2;

      if (!needsToggle) {
        inner.classList.remove('is-collapsed');
        btn.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        return;
      }
      btn.hidden = false;
      syncButton(true);
    }

    function scheduleMeasure() {
      requestAnimationFrame(function () {
        requestAnimationFrame(measure);
      });
    }

    scheduleMeasure();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        scheduleMeasure();
      });
    }

    btn.addEventListener('click', function () {
      var collapsed = !inner.classList.contains('is-collapsed');
      syncButton(collapsed);
    });
  }

  function initUspExpandablesInList(section) {
    if (!section || !section.querySelector) return;
    var list = section.querySelector('.collection-usps-accordion-list');
    if (!list) return;
    list.querySelectorAll('[data-usp-expandable]').forEach(function (inner) {
      if (inner.classList.contains('collection-usps-expandable-text--intro')) return;
      var btn = inner.nextElementSibling;
      bindItem(inner, btn);
    });
  }

  function bindIntroWithList(inner, btn, list) {
    if (!inner || !btn || inner.dataset.uspExpandBound === 'true') return;
    inner.dataset.uspExpandBound = 'true';

    var more = btn.querySelector('.collection-usps-accordion-toggle-text-more');
    var close = btn.querySelector('.collection-usps-accordion-toggle-text-close');
    if (!more || !close) return;

    var section = inner.closest('.collection-usps-accordion-section');

    function syncIntro(collapsed) {
      inner.classList.toggle('is-collapsed', collapsed);
      btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      more.hidden = !collapsed;
      close.hidden = collapsed;
      if (list) list.hidden = collapsed;
    }

    function measureIntro() {
      inner.classList.remove('is-collapsed');
      if (list) list.hidden = false;
      void inner.offsetHeight;
      var fullHeight = inner.scrollHeight;
      inner.classList.add('is-collapsed');
      void inner.offsetHeight;
      var clampedHeight = inner.clientHeight;
      var needsToggle = fullHeight > clampedHeight + 2;

      if (!needsToggle) {
        inner.classList.remove('is-collapsed');
        btn.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        if (list) list.hidden = false;
        initUspExpandablesInList(section);
        return;
      }

      initUspExpandablesInList(section);
      btn.hidden = false;
      syncIntro(true);
    }

    function scheduleMeasureIntro() {
      requestAnimationFrame(function () {
        requestAnimationFrame(measureIntro);
      });
    }

    scheduleMeasureIntro();

    btn.addEventListener('click', function () {
      var collapsed = !inner.classList.contains('is-collapsed');
      syncIntro(collapsed);
    });
  }

  function init(root) {
    var scope = root && root.querySelector ? root : document;
    var searchRoot =
      scope.matches && scope.matches('.collection-usps-accordion-section')
        ? scope
        : scope.querySelector && scope.querySelector('.collection-usps-accordion-section');
    if (!searchRoot) searchRoot = scope;

    var introInner = searchRoot.querySelector(
      '.collection-usps-expandable-text--intro[data-usp-expandable]'
    );
    var list = searchRoot.querySelector('.collection-usps-accordion-list');

    if (introInner && list) {
      var introBtn = introInner.nextElementSibling;
      if (introBtn && introBtn.classList.contains('collection-usps-accordion-toggle')) {
        bindIntroWithList(introInner, introBtn, list);
        return;
      }
    }

    initUspExpandablesInList(searchRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) {
      init(event.target);
    }
  });
})();
